import type { QuizQuestionPrompt } from 'bundles/compound-assessments/types/FormParts';
import type { InVideoQuestion } from 'bundles/video-quiz/types';

/**
 * A model used to represent an in-video quiz that is shown while watching lecture videos.
 */
class VideoQuiz {
  /**
   * The questions in the quiz.
   */
  declare public readonly questions: InVideoQuestion<QuizQuestionPrompt>[];

  /**
   * The session ID for the quiz.
   */
  declare public readonly sessionId: string;

  constructor({ sessionId, questions }: { sessionId: string; questions: InVideoQuestion<QuizQuestionPrompt>[] }) {
    this.sessionId = sessionId;
    this.questions = questions;
  }
}

export default VideoQuiz;
